const guide = {
    start_building: 'เริ่มสร้าง',
    get_started: 'เริ่มต้น',
    categories: {
        featured: 'ยอดนิยมและสำหรับคุณ',
        Traditional: 'เว็บแอปแบบดั้งเดิม',
        SPA: 'แอปหน้าเดียว',
        Native: 'เนทีฟ',
        MachineToMachine: 'เครื่องกับเครื่อง',
        Protected: 'การผสานแบบไม่ใช้ SDK',
        ThirdParty: 'แอปของบุคคลที่สาม',
        SAML: 'แอป SAML',
    },
    filter: {
        title: 'กรองเฟรมเวิร์ก',
        placeholder: 'ค้นหาเฟรมเวิร์ก',
    },
    checkout_tutorial: 'ชมบทแนะนำ {{name}}',
    do_not_need_tutorial: 'ถ้าไม่ต้องการบทแนะนำ สามารถดำเนินการต่อโดยไม่มีคู่มือเฟรมเวิร์กได้',
    finish_and_done: 'เสร็จสิ้น',
    cannot_find_guide: 'หาไกด์ของคุณไม่พบ?',
    describe_guide_looking_for: 'อธิบายไกด์ที่คุณกำลังมองหา',
    request_guide_successfully: 'คำขอของคุณส่งสำเร็จแล้ว ขอบคุณ!',
    app: {
        select_framework_or_tutorial: 'เลือกเฟรมเวิร์กหรือบทแนะนำ',
        guide_modal_title: 'เริ่มด้วย SDK และไกด์',
        modal_subtitle: 'เริ่มต้นพัฒนาแอปของคุณได้อย่างรวดเร็วด้วย SDK และบทแนะนำที่เราสร้างไว้ให้',
        select_a_framework: 'เลือกเฟรมเวิร์ก',
        continue_without_framework: 'สร้างแอปโดยไม่ใช้เฟรมเวิร์ก',
        describe_guide_looking_for_placeholder: 'เช่น ต้องการผสาน Logto เข้ากับแอป Angular',
    },
    api: {
        modal_title: 'เริ่มด้วยบทแนะนำ',
        modal_subtitle: 'เริ่มต้นพัฒนาแอปของคุณได้อย่างรวดเร็วด้วยบทแนะนำที่เราสร้างไว้ให้',
        select_a_tutorial: 'เลือกบทแนะนำ',
        continue_without_tutorial: 'ดำเนินการต่อโดยไม่มีบทแนะนำ',
        describe_guide_looking_for_placeholder: 'เช่น ต้องการปกป้อง API ด้วย deno',
    },
};
export default Object.freeze(guide);
